interface TrackingConfig {
  apiUrl: string;
  clientId: string | null;
  secret: string | null;
  sessionId: string | null;
  debug: boolean;
  autoTrack: {
    pageViews: boolean;
    clicks: boolean;
    formSubmissions: boolean;
    scrolls: boolean;
  };
  scrollThreshold: number;
  batchSize: number;
  flushInterval: number;
}

interface EventData {
  event_type: string;
  event_name?: string;
  payload?: Record<string, any>;
  page_url?: string;
  page_title?: string;
  referrer?: string;
}

interface PageInfo {
  url: string;
  title: string;
  referrer: string | null;
}

interface ElementInfo {
  tag: string;
  id: string | null;
  class: string | null;
  text: string | null;
  href: string | null;
  position: {
    x: number;
    y: number;
  };
}

interface FormInfo {
  id: string | null;
  action: string | null;
  method: string;
  fields: Record<string, string>;
}

interface TrackingEventPayload {
  event_type: string;
  event_name?: string | null;
  payload?: Record<string, any>;
  page_url: string;
  page_title: string;
  referrer: string | null;
  session_id: string;
  timestamp: string;
  client_id: string;
  secret: string;
}

interface ElberegnerTrackingAPI {
  init: (options?: Partial<TrackingConfig>) => void;
  track: (eventType: string, payload?: Record<string, any>) => void;
  trackPageView: (customData?: Record<string, any>) => void;
  trackClick: (element: Element, customData?: Record<string, any>) => void;
  trackFormSubmit: (
    form: HTMLFormElement,
    customData?: Record<string, any>,
  ) => void;
  trackScroll: (customData?: Record<string, any>) => void;
  trackCustom: (eventName: string, customData?: Record<string, any>) => void;
  trackConversion: (
    eventName: string,
    customData?: Record<string, any>,
  ) => void;
  flush: () => void;
  flushImmediate: () => void;
  getSessionId: () => string;
  getConfig: () => TrackingConfig;
  EventTypes: typeof EventTypes;
}

export const EventTypes = {
  PAGE_VIEW: "page_view",
  CLICK: "click",
  KWH_CHANGED: "kwh_changed",
  SUPPLIER_CHANGED: "supplier_changed",
  DEAL_CHANGED: "deal_changed",
  DIFFERENCE_CHANGED: "difference_changed",
  IS_CHEAPER: "is_cheaper",
  IS_NOT_CHEAPER: "is_not_cheaper",
};

const tracking = () => {
  return window.ElberegnerTracking as ElberegnerTrackingAPI | null;
};

export default tracking;
